/** Active feature flags */
export enum FeatureFlag {
  SHOW_COMING_SOON = 'show-coming-soon',
  ENABLE_MARKETPLACE_APPS = 'enable-marketplace-apps',
  ENABLE_DASHBOARD = 'enable-dashboard',
  ENABLE_VVO = 'enable-vvo',
  WIDGET_SELLRATE_COMPARISON = 'widget-sellrate-comparison',
  WIDGET_AVG_PUBLISHED_DAYS_COMPARISON = 'widget-avgLotlinxPublishedDays-comparison',
  WIDGET_AVG_SOLD_VIEWS_COMPARISON = 'widget-avgViewsPerSoldVin-comparison',
  WIDGET_EFFECTIVE_VDP_COST_COMPARISON = 'widget-effectiveCostPerVDP-comparison',
  WIDGET_TOTAL_SHOPPERS_COMPARISON = 'widget-totalShoppersDelivered-comparison',
  WIDGET_TOTAL_VDP_VIEWS_COMPARISON = 'widget-totalVDPViews-comparison',
  WIDGET_VINS_PUBLISHED_COMPARISON = 'widget-vinsPublished-comparison',
  WIDGET_VINS_SOLD_COMPARISON = 'widget-vinsSold-comparison',
  WIDGET_VDP_VIEWS_BAR = 'widget-VDPViews-bar',
  WIDGET_DOL_BAR = 'widget-daysOnLot-bar',
  WIDGET_INV_COUNT_DONUT = 'widget-inventoryCount-donut',
  ENABLE_CHAT = 'enable-chat',
  ENABLE_BEFORE_AND_AFTER = 'enable-before-and-after',
  ENABLE_MARKET_INSIGHTS = 'enable-market-insights',
  ENABLE_DEALER_LANDING_PAGE = 'enable-dealer-landing-page',
  CAMPAIGN_EDIT_10_DAY_EXCEPTION_USERS = 'campaign-edit-10-day-exception-users',
  BA_METRIC_PRICE_TO_MARKET = 'ba-metric-price-to-market',
  BA_METRIC_STOCK_SALE = 'ba-metric-stock-sale',
  BA_METRIC_TURN_RATE = 'ba-metric-turn-rate',
  BA_METRIC_CONVERSIONS = 'ba-metric-conversion',
  BA_METRIC_NET_NEW_SHOPPERS = 'ba-metric-net-new-shoppers',
  BA_METRIC_VINS_VIEWED_PCT = 'ba-metric-vins-viewed-pct',
  BA_METRIC_VINS_PUBLISHED_PCT = 'ba-metric-vi-ns-pubished-pct',
  BA_METRIC_PVR = 'ba-metric-pvr',
  BA_METRIC_SELL_DOWN_RATE = 'ba-metric-sell-down-rate',
  BA_METRIC_AVG_MARKDOWN = 'ba-metric-avg-markdown',
  BA_METRIC_DAYS_TO_SALE = 'ba-metric-days-to-sale',
  BA_METRIC_FRONT_END_GROSS = 'ba-metric-front-end-gross',
  BA_METRIC_VOLUME = 'ba-metric-volume',
  BA_METRIC_MARKET_SHARE = 'ba-metric-market-share',
  BA_METRIC_LEADS = 'ba-metric-leads',
  BA_METRIC_SOLD_TO_HOLD = 'ba-metric-sold-to-hold',
  BA_METRIC_DAYS_SUPPLY = 'ba-metric-days-supply',
  BA_METRIC_AVG_MARKDOWN_PCT = 'ba-metric-average-markdown-percent',
  ENABLE_MARKET_OPPORTUNITY = 'page-enable-market-opportunity',
  INVENTORY_TABLE_AI_RECOMMENDED_BUDGET_INCREASE_COLUMN = 'inventory-table-ai-recommended-budget-increase-column',
  ENABLE_LOCAL_MARKET_SETTINGS = 'enable-local-market-settings',
  ENABLE_CAMPAIGN_CREATION = 'enable-campaign-creation',
  ENABLE_GEO_CONFIG_SETTING = 'enable-geo-config-setting',
  ENABLE_SHOWROOM = 'enable-showroom',
  ENABLE_LX_VIDEO_CONFIG_SETTING = 'enable-lx-video-config-setting',
  ENABLE_PHOTO_AI_SETTING = 'enable-photo-ai-setting',
  ENABLE_VMX_ACCESS = 'enable-vmx-access',
  ENABLE_MARKET_MAPS = 'enable-market-maps',
  ENABLE_CONVERSION_REPORT = 'enable-conversion-report',
  ENABLE_RISK_ANALYSIS = 'enable-risk-analysis',
  ENABLE_RISK_OVERVIEW = 'enable-risk-overview-page',
  ENABLE_ROI_REPORT = 'enable-roi-report-page',
  ENABLE_MARKET_INSIGHTS_PAGE = 'enable-market-insights-page',
  ENABLE_ADMIN_ACTIVITY = 'enable-admin-activity',
  ENABLE_USER_LOGIN = 'enable-user-login',
  ENABLE_LEX_CHAT = 'enable-lex-chat',
  ENABLE_LOGIN_PAGE_DOWNTIME_NOTIFICATION = 'enable-login-page-downtime-notification',
  ENABLE_CACHE_REBUILD = 'enable-cache-rebuild',
  ENABLE_CAMPAIGN_OVERVIEW = 'enable-campaign-overview',
  ENABLE_REPORT_GENERATION = 'enable-report-generation',
  ENABLE_PERFORMANCE_RESULTS = 'enable-performance-results',
  ENABLE_VSR = 'enable-vsr',
  ENABLE_CAMPAIGN_EDITING = 'enable-campaign-editing',
  ENABLE_VINBOOST_VDP = 'enable-vinboost-vdp',
  ENABLE_VINBOOST_INVENTORY_PAGE = 'enable-vin-boost-inventory-page',
  ENABLE_UPLIFT_CAMPAIGN = 'enable-uplift-campaign',
  ENABLE_IDP = 'enable-idp',
  ENABLE_IDP_ORIGINAL = 'enable-idp-original',
  ENABLE_MARKET_INSIGHTS_V2 = 'enable-market-insights-v-2',
  ENABLE_MANUAL_SHOPPER_ADJUSTMENT = 'enable-manual-shopper-adjustment',
  ENABLE_PII_VERIFICATION = 'enable-pii-verification',
  LOCAL_MARKET_SETTING_EDIT_EXCEPTIONS = 'local-market-setting-edit-exceptions',
  ENABLE_INVENTORY_HEALTH = 'enable-inventory-health',
}
